import { render } from "./MobileSignup.vue?vue&type=template&id=71353fbe&scoped=true&ts=true"
import script from "./MobileSignup.vue?vue&type=script&lang=ts"
export * from "./MobileSignup.vue?vue&type=script&lang=ts"

import "./MobileSignup.vue?vue&type=style&index=0&id=71353fbe&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71353fbe"]])

export default __exports__